/**
 * ClientDetailsTabLayout – Shared layout for Client Details tabs.
 * Enforces consistent Grid structure with optional client info panel.
 *
 * Props:
 *   showClientPanel  {boolean}  Whether to show the client panel (default: true)
 *   clientPanel      {node}     React node for the client panel (ClientDetailsSection)
 *   children         {node}     Main tab content
 */
import React from 'react';
import { Grid, Box } from '@mui/material';

const ClientDetailsTabLayout = ({
  showClientPanel = true,
  clientPanel,
  children,
  sx = {},
}) => {
  return (
    <Grid container spacing={2} sx={{ minHeight: 480, width: '100%', minWidth: 0, maxWidth: '100%', ...sx }}>
      {showClientPanel && clientPanel && (
        <>
          {clientPanel}
          <Grid item xs={12} sm={8}>
            <Box sx={{ minWidth: 0 }}>{children}</Box>
          </Grid>
        </>
      )}
      {(!showClientPanel || !clientPanel) && (
        <Grid item xs={12}>
          <Box sx={{ minWidth: 0 }}>{children}</Box>
        </Grid>
      )}
    </Grid>
  );
};

export default ClientDetailsTabLayout;
